// Footer.
//
// Three small things: the back to the top button, asking Trustpilot to draw
// itself again after the theme editor reloads the section, and the newsletter
// form.
//
// The form is Shopify's own customer form. An address that cannot be one is
// stopped here. Anything else is posted in the background, so signing up does
// not reload the page: the same fields go to the same endpoint, and Shopify
// answers with a redirect carrying customer_posted=true when the address went
// in. With no fetch to post it with, the submit is handed back and the form
// posts the way it would with no script at all, which is what Liquid's own
// form.errors and form.posted_successfully? branches are still there for.

(function () {
  'use strict';

  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function setup(root) {
    if (root.dataset.nextdevFooterInit) return;
    root.dataset.nextdevFooterInit = '1';

    // back to the top
    var top = root.querySelector('[data-nextdev-footer-top]');
    if (top) {
      top.addEventListener('click', function () {
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      });
    }

    // Trustpilot draws itself when its script arrives. On a section reload
    // the script is already there, so the box is asked to draw again.
    var trustpilot = root.querySelector('[data-nextdev-footer-trustpilot]');
    if (trustpilot && window.Trustpilot && window.Trustpilot.loadFromElement) {
      window.Trustpilot.loadFromElement(trustpilot, true);
    }

    // the letter
    var form = root.querySelector('[data-nextdev-footer-form]');
    var email = root.querySelector('[data-nextdev-footer-email]');
    var note = root.querySelector('[data-nextdev-footer-note]');
    var button = form && form.querySelector('[type="submit"]');
    if (!form || !email) return;

    function say(text) {
      if (note) note.textContent = text || '';
    }

    function line(name, fallback) {
      return form.getAttribute(name) || fallback;
    }

    // everything the form holds, in the shape a form post sends it
    function body() {
      var fields = new FormData(form);
      var parts = [];
      fields.forEach(function (value, key) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return parts.join('&');
    }

    var busy = false;

    form.addEventListener('submit', function (event) {
      var value = email.value.trim();
      if (!EMAIL.test(value)) {
        event.preventDefault();
        say(line('data-nextdev-footer-invalid', 'Please give an email address we can write to.'));
        email.focus();
        return;
      }

      // A preview has no shop to post to, so it answers here instead. The
      // theme's form carries no such flag.
      if (form.hasAttribute('data-nextdev-footer-demo')) {
        event.preventDefault();
        say(line('data-nextdev-footer-thanks', 'Thank you.'));
        form.reset();
        return;
      }

      // Nothing to post it with, so the form goes the way it always would and
      // the page reloads. Liquid draws the note on the way back.
      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (busy) return;
      busy = true;
      say('');
      if (button) button.setAttribute('aria-disabled', 'true');

      fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'text/html'
        },
        body: body()
      }).then(function (response) {
        // Shopify answers a customer form with a redirect, and adds
        // customer_posted=true to it only when the address went in. It is the
        // one thing in the answer that says which way it went.
        var done = !!(response && response.url && response.url.indexOf('customer_posted=true') > -1);
        if (done) {
          say(line('data-nextdev-footer-thanks', 'Thank you.'));
          form.reset();
        } else {
          say(line('data-nextdev-footer-error', 'That did not go through. Please try again.'));
        }
      }).catch(function () {
        say(line('data-nextdev-footer-error', 'That did not go through. Please try again.'));
      }).then(function () {
        busy = false;
        if (button) button.removeAttribute('aria-disabled');
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-nextdev-footer]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor draws a section again after a change
  document.addEventListener('shopify:section:load', start);
})();